import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { TablePdf } from "../TablePdf/TablePdf";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { DataTableCell } from "@david.kucsai/react-pdf-table";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewArticlegroupsExtended(props) {
  let totalCount = 0;
  let totalAmount = 0;

  let articles = props.articles;

  let data = [];
  Object.keys(articles).forEach((plu) => {
    Object.keys(articles[plu]).forEach((name) => {
      Object.keys(articles[plu][name]).forEach((price) => {
        let article = articles[plu][name][price];

        let articlegroupName = "ONBEKEND";
        if (article["articlegroup_name"] != null) {
          articlegroupName = article["articlegroup_name"];
        }

        totalCount += article["amount_paid"];
        totalAmount += price * article["amount_paid"];
        data.push({
          articlegroupName: articlegroupName,
          plu: plu,
          name: name,
          price: GetCurrency() + (price / 100.0).toFixed(2),
          numberPaid: article["amount_paid"],
          amountPaid: (price * article["amount_paid"]) / 100.0,
        });
      });
    });
  });

  let articlegroups = {};
  data.forEach((row) => {
    if (articlegroups[row.articlegroupName] == null) {
      articlegroups[row.articlegroupName] = [];
    }
    articlegroups[row.articlegroupName].push(row);
  });

  Object.keys(articlegroups).forEach((articlegroupName) => {
    articlegroups[articlegroupName] = articlegroups[articlegroupName].reduce(
      (r, k) => {
        return {
          articlegroupName: k.articlegroupName,
          numberPaid: k.numberPaid + r.numberPaid,
          amountPaid: k.amountPaid + r.amountPaid,
        };
      },
      { numberPaid: 0, amountPaid: 0 }
    );
  });
  Object.keys(articlegroups).forEach((articlegroupName) => {
    articlegroups[articlegroupName].amountPaid = GetCurrency() + articlegroups[articlegroupName].amountPaid.toFixed(2);
  });

  data = Object.keys(articlegroups).map((articlegroupName) => {
    return articlegroups[articlegroupName];
  });

  data = data.sort((a, b) => {
    if (a.numberPaid < b.numberPaid) {
      return 1;
    } else if (a.numberPaid > b.numberPaid) {
      return -1;
    } else {
      return 0;
    }
  });

  const getPdfView = () => {
    return (
      <TablePdf data={data}>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Articlegroup</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Aantal verkocht
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Bedrag verkocht
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <DataTableCell weighting={0.3} getContent={(r) => r.articlegroupName} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.numberPaid} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.amountPaid} />
        </TableBodyPDF>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {totalCount}
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {GetCurrency() + (totalAmount / 100.0).toFixed(2)}
          </TableCellPDF>
        </TableHeaderPDF>
      </TablePdf>
    );
  };

  props.createPdf(getPdfView());
  //
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Articlegroup</TableCell>
            <TableCell align={"right"}>Aantal verkocht</TableCell>
            <TableCell align={"right"}>Bedrag verkocht</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((r) => {
            return (
              <TableRow>
                <TableCell>{r.articlegroupName}</TableCell>
                <TableCell align={"right"}>{r.numberPaid}</TableCell>
                <TableCell align={"right"}>{r.amountPaid}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align={"right"}>{totalCount}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(totalAmount / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
